import React from 'react';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import InputField from 'components/InputField';
import { useTranslation } from 'react-i18next';
import useValidations from 'router/subrouters/Auth/hooks/useValidations';
import ContactNumberField from 'components/ContactNumberField';
import EmailField from 'components/EmailField';

import './ConfirmDetails.styles.scss';
import './ConfirmDetails.styles.responsive.scss';

type ConfirmDetailsProps = {
  className?: string;
};

const ConfirmDetails: React.FC<ConfirmDetailsProps> = (props) => {
  const { className } = props;

  const commonValidations = useValidations();

  const { t } = useTranslation();

  const classes = classNames('confirm-details', className);

  return (
    <div className={classes}>
      <Field
        name="firstName"
        label={t('firstName')}
        component={InputField}
        validate={commonValidations.name}
        required
      />
      <Field
        name="lastName"
        label={t('lastName')}
        component={InputField}
        validate={commonValidations.name}
        required
      />
      <ContactNumberField required />
      <EmailField required />
    </div>
  );
};

export default ConfirmDetails;
